import http from "../http-common";

class incrementalService {

  insertData(type, data) {
    return http.put(`/incrementalData/${type}`, data);
  }

  getIncrementalRecords(batchId) {
    return http.get(`/incrementalData/${batchId}`);
  }

}

export default new incrementalService();